import React from 'react';
import PropTypes from 'prop-types';

export default class Refocus extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node,
        routes: PropTypes.arrayOf(PropTypes.object).isRequired,
    }
    componentDidUpdate () {
        const {routes} = this.props;

        // Do not refocus if any of the routes are opting out of this
        const noRefocus = routes.some(
            route => route.shouldRefocusRouteContent && !route.shouldRefocusRouteContent(),
        );

        const focusableNode = document.getElementById('route__content');
        if (focusableNode && !noRefocus) {
            focusableNode.focus();
        }
    }
    render () {
        return <div>{ this.props.children }</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/RefocusRouteContent.js